import React, { Component } from 'react';
import { Well, FormControl, Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'

import { setDeliveryTime } from '../actions'
import { getDateDeliveryTime } from '../utils'
import { getDateDeliveryTimeEven } from '../utils'
import _ from 'lodash'

class DeliveryTime extends Component {

    renderDeliveryTime() {
        let current_time = new Date
        let current_hours = current_time.getHours()
        //let current_hours = 8
        current_hours < 7 ? current_hours = 7 : ''
        let id = 0
        let dropdown = {}
        let count = 0
        for (var i = current_hours; i < 15; i++) {
            dropdown[count++] = (i + 1) + '.00-' + (i + 2) + '.00' + getDateDeliveryTime(current_time)
        }
        for (var i = 8; i < 15; i++) {
            dropdown[count++] = (i) + '.00-' + (i + 1) + '.00' + getDateDeliveryTime(current_time, 'tmr')
        }
        return _.map(dropdown, dropdown => (
            <option key={id++} value={dropdown} >{dropdown}</option>
        ))
    }
    renderDeliveryTimeEven(){
        const day = new Date();
        var weekend = Number(day.getDay() + 1)
        var date=day.getDate()
        let id = 0
        let dropdown = {}
        let count = 0
        var nextweeksat
        var nextweeksun
       
        
        nextweeksat = new Date(day.getFullYear(), day.getMonth(),day.getDate()+(7-weekend));
        nextweeksun = new Date(day.getFullYear(), day.getMonth(),day.getDate()+(8-weekend));
    if(weekend!==1){  
            dropdown[count++] = 'วันเสาร์:'+getDateDeliveryTimeEven(nextweeksat)
            dropdown[count++] = 'วันอาทิตย์:'+getDateDeliveryTimeEven(nextweeksun)
      }else{
            nextweeksun = new Date(day.getFullYear(), day.getMonth(),day.getDate());
            dropdown[count++] = 'วันอาทิตย์:'+getDateDeliveryTimeEven(nextweeksun)
      }
        
        return _.map(dropdown, dropdown => (
            <option key={id++} value={dropdown} >{dropdown}</option>
        ))

    }
    renderPreorderTime() {
        const availableTimes = [
            { date: 2, start: 8, end: 18, },
            { date: 3, start: 8, end: 20, },
            { date: 4, start: 3, end: 9, },
        ]
        const lastDate = 4
        const monthString = 'ก.พ.'
        const currentTime = new Date
        const currentHours = currentTime.getHours()
        const currentDate = currentTime.getDate()
        var result = []

        availableTimes.map(availableTime => {
            const startHour = availableTime.date == currentDate ?
                Math.max(currentHours, availableTime.start)
                : availableTime.start
            for (var i = startHour; i < availableTime.end; i++) {
                if (currentDate < availableTime.date || currentDate > lastDate) {
                    const value = `${i}.00-${i + 1}.00 ( ${availableTime.date} ${monthString} )`
                    result.push(
                        <option key={`d${availableTime.date}h${i}`} value={value} >{value}</option>
                    )
                }
            }
        })
        return result
    }

    render() {
        const { preorder } = this.props
        return (
            <div style={{ padding: 10 }}>
                <h3 style={{whiteSpace:'pre'}}>{preorder ? 'กิจกรรมเสาร์นี้มีเฮ โปรโมชั่น ค่าส่ง 50 บาททั่วกรุงเทพ(ส่งเฉพาะวันเสาร์และวันอาทิตย์)' : 'กรุณาเลือกช่วงเวลาจัดส่ง - รับสินค้า'}: </h3>
                <Row>
                    <FormControl componentClass="select" defaultValue=''
                        onChange={e => { this.props.setDeliveryTime(e.target.value, preorder) }}
                    >
                        <option style={{ display: 'none' }} disabled value={''} >{preorder ?'คลิกเพื่อเลือกวันจัดส่ง - รับสินค้า(เวลาจัดส่งจะแจ้งให้ทราบภายหลัง)':'คลิกเพื่อเลือกช่วงเวลาจัดส่ง - รับสินค้า'}:</option>
                        {
                            !preorder ?
                                this.renderDeliveryTime()
                                // : this.renderPreorderTime()
                                 :this.renderDeliveryTimeEven()
                                //:this.renderDeliveryTime()


                        }
                    </FormControl>
                    {this.props.show_alert && !this.props.delivery_time ? <h5 style={{ color: 'red' }}>**เลือกช่วงเวลาจัดส่ง - รับสินค้า**</h5> : ''}
                </Row>
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        delivery_time: state.delivery_time_reducer
    }
}

export default connect(mapStateToProps, { setDeliveryTime })(DeliveryTime)


// WEBPACK FOOTER //
// ./src/components/component_delivery_time.js